import { GridColDef, GridRowsProp } from '@mui/x-data-grid';
import { useContext, useEffect, useState } from 'react';
import { AppContext } from '../../../app-context';
import IGridComponent from '../../../components/grid/i-grid.component';
import TitlePanel from '../../../components/title-panel/title-panel.component';
import { PAGE_SIZE } from '../../common/constants';
import { formatDateLong, isEmptyArray } from '../../common/util.services';
import { getLog, deleteLog } from '../amazon.services';
import { useNavigate } from 'react-router-dom';

const AmazonLog = () => {
  const appContext = useContext(AppContext);
  const rows: GridRowsProp = [];
  const [logData, setLogData] = useState(rows);
  const navigate = useNavigate();
  const columns: GridColDef[] = [
    { field: 'date', headerName: 'Date', filterable: false, sortable: false, editable: false, width: 180,
      valueFormatter: (date: any) => formatDateLong(date)
    },
    { field: 'parameter', headerName: 'Parameter', filterable: false, sortable: false, editable: false, width: 280  },
    { field: 'detail', headerName: 'Detail', filterable: false, sortable: false, editable: false, width: 800  }
  ];
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(PAGE_SIZE);
  const [totalRows, setTotalRows] = useState(0);

  useEffect(() => {
    if (isEmptyArray(rows)) {
      setLoading(true);
      getLog(page, pageSize, appContext,
        (response: any) => {
          setLogData(response.data.content);
          setTotalRows(response.data.totalElements);
          appContext.setShowLoader(false);
          setLoading(false);
        }, (error: any) => {
          console.log(error);
          appContext.setShowLoader(false);
          appContext.setErrorMessage(error.message);
          setLoading(false);
        });
    }
  }, [page, pageSize]);

  const onPaginationModelChange = (evt: any) => {
    setPage(evt.page);
    setPageSize(evt.pageSize);
  }

  const deleteLogData = (row: any) => {
    setLoading(true);
    deleteLog(row.rowId, appContext,
      (response: any) => {
        appContext.setShowLoader(false);
        setLoading(false);
        navigate(0);
      }, (error: any) => {
        console.log(error);
        appContext.setShowLoader(false);
        appContext.setErrorMessage(error.message);
        setLoading(false);
      });
  }
  
  const getMainPanel = () => {
    return <>
      <IGridComponent title={''} rows={logData} columns={columns} loading={loading}
        paginationType="server" paginationModelChange={onPaginationModelChange} totalRows={totalRows}
        showAction={true} showApproveAction={false} showDeleteAction={true} showAddBtn={false} showEditAction={false}
        getRowId={(row: any) => row.rowId} maxHeight={450} handleDeleteAction={deleteLogData}/>
    </>
  }

  return <TitlePanel title='Logs' panelBody={getMainPanel()} />
}

export default AmazonLog;